//use mixin to cache results
export const globalMixin = {
    computed: {
        isSidePanelCheckboxDisabled(){
            let result = false

            if( this.$store.state.UserInterface.isViewDisabled ) result = true;
            if( this.$store.state.UserInterface.isCategoryOnly ) result = true;

            return result;
        },

        BasicSpecsUserInterface(){
            return this.$store.state.UserInterface['BasicSpecs'];   
        },

        SetsubiSheetUserInterface(){
            return this.$store.state.UserInterface['SetsubiSheet'];    
        },

        GaibuListUserInterface(){
            return this.$store.state.UserInterface['GaibuList'];
        },

        isViewDisabled(){
            return this.$store.state.UserInterface.isViewDisabled;
        },

        isSheetCountsModified(){
            return this.$store.state.UserInterface.IsSheetItemsCountModified;
        },

        //2025-05-16 jazz
        SiyoCode(){
            return this.$store.state.PlanInfo.SiyoCode;
        }
    },
 
    methods:{
        ShowItemDetails( object, main, cat, subcat, specs, selectedTexture ){
            // 2025-04-08 jazz, if hint are found return immediately
            const hint = this.$SRSFunc.SRSDefaults.CellHintArr.find(item => item.id == object.id)?.hint

            if( hint ) return hint;

            let detailStr = '';

            if( process.env.MIX_DEPLOYMENT == 'ichijo' && process.env.MIX_DEBUG == 'true' ){
                let result = null 
                
                detailStr = `id: ${object.id}\n
                             sortno: ${object.sortno}\n
                             isparentcheckbox: ${object.isparentcheckbox}\n
                             isedit: ${object.isedit}\n
                             isselected: ${object.isselected}\n
                             selectionid: ${object.selectionid}\n
                             seq: ${object.seq}\n
                             icadtableid: ${object.icadtableid}\n
                             `
                if ( object.groupid > 0 ) {
                    detailStr = `${detailStr}parentid: ${object.parentid}\nhousetype: ${object.housetype}`
                }else{
                    detailStr = `${detailStr}folderid: ${object.folderid}\nistexture: ${object.istexture}`
                }
            }else{
                let tmpmain   = main || main != null  ? `${main.items}` + '| ' : '';
                let tmpcat    = cat  || cat != null  ? `${cat.items}` + '| ' : '';
                let tmpsubcat = subcat || subcat != null ? `${subcat.items}` + '| ' : '';
                let tmpspecs  = specs  || specs != null ? `${specs.items}` + '| ' : '';

                if ( object.groupid > 0 ){
                      if(object.istexture === 1 ){
                        if(`${object.items}` === `${selectedTexture}`){
                            let fCat = tmpcat === 'undefined| '? '': tmpcat;
                            let fsubcat = tmpsubcat === 'undefined| '? '': tmpsubcat;
                            let fspecs = tmpspecs === 'undefined| '? '': tmpspecs;

                            detailStr =  tmpmain + ' ' + fCat + ' ' + fsubcat + ' ' + fspecs + ' ' + selectedTexture
                        }
                        else{
                            detailStr = `${object.items}`
                        }
                      }else{
                            detailStr = `${object.items}`      
                      }
      
                }else{
                    if( `${object.texturename}` === `${selectedTexture}` ){
                        detailStr =  tmpmain + ' ' + tmpcat + ' ' +tmpsubcat + ' ' + tmpspecs + ' ' + selectedTexture
                    }else{
                        detailStr = `${object.texturename}`
                    }
                }
            }

            this.$SRSFunc.SRSDefaults.CellHintArr.push( { id:object.id, hint: detailStr} );
            return detailStr;
        }
    }



















};


 